import UserDetailsSidebarStatus from './UserDetailsSidebarStatus';

export default UserDetailsSidebarStatus;
